$(document).ready(function () {
  // WYSIWYG document link
  if ($(".document-link").length > 0) {
    $(".document-link").each(function () {
      var content = "";
      content +=
        "<img class='document-icon' src='_resources/app/client/assets/icons/document.png' alt='document'>";
      content += $(this).text();
      $(this).empty();
      $(this).append(content);
    });
  }
});
